import { defineStore } from 'pinia'
import { AUTH_TOKEN_NAME, AUTH_USER_NAME } from '../Config/global'
import { computed, ref } from 'vue';

export const useAuthStore = defineStore('auth', () => {
    const user = ref(JSON.parse(localStorage.getItem(AUTH_USER_NAME)) || null);
    const token = ref(localStorage.getItem(AUTH_TOKEN_NAME) || null)

    const isLoggedIn = computed(() => !!token.value);

    const setToken = (newToken) => {
        localStorage.setItem(AUTH_TOKEN_NAME, newToken);
        token.value = newToken
    }

    const setUser = (newuser) => {
        localStorage.setItem(AUTH_USER_NAME, JSON.stringify(newuser));
        user.value = newuser;
    }

    const logout = () => {

        user.value = null;
        token.value = null;

        localStorage.removeItem(AUTH_TOKEN_NAME)
        localStorage.removeItem(AUTH_USER_NAME)
    }

    return {
        user, token, isLoggedIn, setToken, setUser, logout
    }
});
